import { Form, Validators, field } from "fw-model";

const { required, isMinLength } = Validators;

export class ResetPasswordForm extends Form {
  @field("Password", required, isMinLength(8))
  public Password: string = null;
}
